// extracted by mini-css-extract-plugin
module.exports = {"root":"Scanner_root__wyl84","viewFinder":"Scanner_viewFinder__UQ9jT","deviceSelector":"Scanner_deviceSelector__cYC5E"};